module.exports = __webpack_public_path__ + "img/scan 4.a58e7ec1.jpg";